// extracted by mini-css-extract-plugin
export default {"container":"_1Sfwr","scrollBarColor":"Id4Jd","cardContainer":"_1AIdC","listContainer":"_3TEce"};